import axios, { AxiosResponse } from 'axios';
import {
	IAuthenticatedUserApiResponse,
	IAuthenticatedUserModel,
	IUnAuthenticatedUserModel,
	IDeleteThirdPartyResponse,
	ISendLinkToThirdPartyResponse,
} from './grant-access.model';
import { API_BASE_URL } from 'src/helper/constants';
import { apiCatchHandler, apiCatchHandlerNoData } from 'src/helper/utils';

export const getThirdPartyAuthorizedUsers = (callback: (auResponse: IAuthenticatedUserApiResponse) => void) => {
	const auResponse: IAuthenticatedUserApiResponse = {
		userDetails: [],
		error: false,
	};
	axios
		.get(`${API_BASE_URL}/api/authorizedUser/get-auregistration-list`)
		.then((response: AxiosResponse<IAuthenticatedUserModel[]>) => {
			const { data } = response;
			auResponse.userDetails = data;
			callback(auResponse);
		})
		.catch((error) => {
			auResponse.error = true;
			apiCatchHandler(error, auResponse, callback);
		});
};

export const addNewThirdPartyUser = (
	data: IUnAuthenticatedUserModel,
	successCallback: (uri?: string) => void,
	errorCallback: (errorResponse: { status: number; data: string } | undefined) => void,
) => {
	data.accessibleModules = data.accessibleModules.split(',').map(Number).sort().join(',');
	axios
		.post(`${API_BASE_URL}/api/authorizedUser/add-RegistrationDetails`, data, { withCredentials: true })
		.then((response: AxiosResponse) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, () => errorCallback(error.response));
		});
};

export const updateThirdPartyUser = (
	data: IUnAuthenticatedUserModel,
	successCallback: (uri?: string) => void,
	errorCallback: (errorResponse: { status: number; data: string } | undefined) => void,
) => {
	data.accessibleModules = data.accessibleModules.split(',').map(Number).sort().join(',');
	axios
		.post(`${API_BASE_URL}/api/authorizedUser/update-RegistrationDetails`, data, { withCredentials: true })
		.then((response: AxiosResponse) => {
			const { data } = response;
			successCallback(data);
		})
		.catch((error) => {
			apiCatchHandlerNoData(error, () => errorCallback(error.response));
		});
};

export const deleteThirdPartyUser = (
	auRegistrationId: number,
	callback: (deleteThirdPartyResponse: IDeleteThirdPartyResponse) => void,
) => {
	const deleteThirdPartyResponse: IDeleteThirdPartyResponse = {
		isSuccess: false,
		error: false,
	};
	axios
		.delete(`${API_BASE_URL}/api/authorizedUser/delete-au-registration/${auRegistrationId}`)
		.then((response: AxiosResponse<boolean>) => {
			const { data } = response;
			deleteThirdPartyResponse.isSuccess = data;
			callback(deleteThirdPartyResponse);
		})
		.catch((error) => {
			deleteThirdPartyResponse.error = true;
			apiCatchHandler(error, deleteThirdPartyResponse, callback);
		});
};

export const sendLinkToThirdPartyUser = (
	auRegistrationId: number,
	callback: (sendLinkToThirdPartyUserResponse: ISendLinkToThirdPartyResponse) => void,
) => {
	const sendLinkToThirdPartyUserResponse: ISendLinkToThirdPartyResponse = {
		isSuccess: false,
		error: false,
	};
	axios
		.put(`${API_BASE_URL}/api/authorizedUser/send-access-link/${auRegistrationId}`)
		.then((response: AxiosResponse<boolean>) => {
			sendLinkToThirdPartyUserResponse.isSuccess = true;
			callback(sendLinkToThirdPartyUserResponse);
		})
		.catch((error) => {
			sendLinkToThirdPartyUserResponse.error = true;
			apiCatchHandler(error, sendLinkToThirdPartyUserResponse, callback);
		});
};
